<template>
  <v-dialog width="350px" persistent v-model="editDialog">
    <v-btn  slot="activator" icon class="">
      <v-icon small light class="text--lighten-1">edit</v-icon>
    </v-btn>
    <v-card>
      <v-container class="mt-0">
        <v-layout row wrap>
          <v-flex xs12 class="mb-2">
            <v-card-title class="justify-center"><h2>Edit Trial Coordinators</h2></v-card-title>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 v-for="item in editedCoordinators" v-bind:key="item.objectName">
            {{item.name}}
          </v-flex>
          <v-flex xs12>
              <v-text-field
                v-model="editedCoordinators"
                label="Coordinator"
                id="CoordinatorName"
              ></v-text-field>
              <v-text-field
                v-model="editedCoordinatorsPhone"
                label="Coordinator Phone Number"
                id="CoordinatorPhone"
              ></v-text-field>
              <v-text-field
                v-model="editedCoordinatorsEmail"
                label="Coordinator Email Address"
                id="CoordinatorEmail"
              ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions class="justify-center">
              <v-btn depressed class="grey lighten-1 white--text" @click="editDialog = false">Cancel</v-btn>
              <v-btn depressed class="white--text cyan " @click="onSaveChanges">Save</v-btn>
              <v-btn dark flat class="red darken-3" @click="onDeleteCoordinator(coordinator)"><v-icon small dark class="text--lighten-1">delete</v-icon></v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['coordinator'],
  data () {
    return {
      editDialog: false,
      editedCoordinators: this.coordinator.coordinatorName,
      editedCoordinatorsPhone: this.coordinator.coordinatorPhone,
      editedCoordinatorsEmail: this.coordinator.coordinatorEmail
    }
  },
  computed: {
    loadCoordinators () {
      return this.$store.getters.loadedCoordinators
    }
  },
  methods: {
    onDeleteCoordinator (coordinator) {
      console.log('Delete this: ' + JSON.stringify(coordinator))
      this.$store.dispatch('deleteCoordinatorData', coordinator)
      this.$router.push('/coordinators')
    },
    onSaveChanges () {
      this.editDialog = false
      this.$store.dispatch('updateCoordinatorData', {
        coordinatorId: this.coordinator.coordinatorId,
        coordinatorName: this.editedCoordinators,
        coordinatorPhone: this.editedCoordinatorsPhone,
        coordinatorEmail: this.editedCoordinatorsEmail
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// EditCoordinatorsDialog.vue?aae09712